import { PenLine } from "lucide-react";
import { IMAGES, DISCIPLINES } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";
import { GhostButton } from "../components/shared/Buttons";

export default function Register() {
  return (
    <>
      <PageHero
        eyebrow="Register"
        title="Take Your Place"
        intro="Athlete and organisation registrations for Kumite Games are not open yet. This page will become the gateway to entry once event details are confirmed."
        image={IMAGES.muaythai}
        testId="register-page-hero"
      />
      <section className="mx-auto max-w-4xl px-5 py-20 text-center sm:px-8 sm:py-28">
        <Reveal>
          <PenLine className="mx-auto h-10 w-10 text-kred" />
          <h2 data-testid="register-coming-soon" className="mt-8 font-display text-6xl uppercase leading-[0.9] tracking-tight text-bone sm:text-7xl">
            Registrations <span className="text-kred">Coming Soon</span>
          </h2>
          <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-slate-400">
            Registration will open once the event date, venue and participating organisations are
            officially confirmed. Entries will be managed alongside each discipline's
            participating organisation.
          </p>
          <div className="mt-12 flex flex-wrap justify-center gap-3">
            {DISCIPLINES.map((d) => (
              <span key={d.slug} className="border border-white/10 px-4 py-2 font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-slate-400">
                {d.name}
              </span>
            ))}
          </div>
          <div className="mt-14 flex flex-wrap justify-center gap-4">
            <GhostButton to="/news" testId="register-news-button">
              Follow Announcements
            </GhostButton>
            <GhostButton to="/contact" testId="register-contact-button">
              Contact Us
            </GhostButton>
          </div>
        </Reveal>
      </section>
    </>
  );
}
